import React, { FunctionComponent } from 'react';
import { useRecording } from 'features/recordings/recordingHooks';
import dayjs from 'utilities/dayjs';
import { formatDateTime } from 'utilities/formatters';

interface RecordingDateProps {
  recordingId: string;
  cssClass?: string;
}

export const RecordingDate: FunctionComponent<RecordingDateProps> = (props) => {
  const recording = useRecording(props.recordingId);

  if (!recording) {
    return null;
  }

  return (
    <time dateTime={recording.createdAt.toString()} className={props.cssClass}>
      {dayjs(recording.createdAt).format(formatDateTime())}
    </time>
  );
};
